__webpack_require__.p = "/points/";